<template>
  <div class="mall-my">
    <div class="mall-my__shell">
      <aside class="mall-my__aside" aria-label="마이페이지 메뉴">
        <header class="mall-my__brand">
          <router-link :to="MALL_MYPAGE_PATH" class="mall-my__brand-link">
            <strong>마이페이지</strong>
            <span>{{ MALL_NAME }}</span>
          </router-link>
          <p v-if="member" class="mall-my__hello">
            <b>{{ member.orgName || member.bossName || member.userId }}</b>
            님
          </p>
        </header>

        <nav v-for="group in MALL_MY_NAV" :key="group.title" class="mall-my__group">
          <h2>{{ group.title }}</h2>
          <ul>
            <li v-for="item in group.items" :key="item.to">
              <router-link
                :to="item.to"
                class="mall-my__link"
                :class="{ 'is-active': isActive(item.to) }"
              >
                {{ item.label }}
              </router-link>
            </li>
          </ul>
        </nav>
      </aside>

      <main class="mall-my__main">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'
import { useMemberAuth } from '@/composables/useMemberAuth'
import { MALL_MYPAGE_PATH, MALL_NAME } from '@/constants/mall'
import { MALL_MY_NAV } from '@/constants/mallMy'

const route = useRoute()
const { member } = useMemberAuth()

function isActive(to: string) {
  if (to === MALL_MYPAGE_PATH) return route.path === to
  return route.path === to || route.path.startsWith(`${to}/`)
}
</script>

<style lang="scss" src="./MallMyLayout.scss"></style>
